module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-industrial.ebd5ae2c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-industrial.png
// module id = 3074
// module chunks = 11